export default "__VITE_ASSET__C6WfRM15__"